import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import RelationshipExists from './RelationshipExists';

const IconPicker = ({
  resource,
}) => {
  return pickFunction(resource, {
    [fr.relationships.icon.name]: () => {
      return (
        <RelationshipExists
          resource={resource}
        />
      );
    },
    [fr.relationships.default.name]: () => null,
  });
};

export default IconPicker;
